export default (id: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {

    try {
        const elt = document.getElementById(id);

        if (elt) {
            elt.scrollIntoView({ behavior: 'smooth' });
        }
        e.preventDefault();
        e.stopPropagation();
        // tslint:disable-next-line:no-empty
    } finally {

    }
}


// WEBPACK FOOTER //
// ./src/utils/scrollToId.tsx